export default __webpack_public_path__ + "static/screenFifthSectionUk-2db4bfed7cd033af01423177ad8cf491.webp";